import { styled } from "@mui/material";
const Container = styled("div")({
  position: "relative",
  '& input[type="search"]': {
    "&::-webkit-search-decoration, &::-webkit-search-cancel-button, &::-webkit-search-results-button, &::-webkit-search-results-decoration": {
      display: "none"
    }
  }
});
export {
  Container
};
